import { createBreakpoints } from '@mui/system';
import type { IThemeOptions } from './index';

const breakpoints = createBreakpoints({
  values: {
    xs: 400,
    sm: 600,
    smallMobile: 320,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
});

export const CommonThemeOptions: IThemeOptions = {
  themeName: 'Common',
  breakpoints,
  components: {
    // mui v5 (fontsizes has changed)
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
        },
        kbd: {
          fontFamily: 'Poppins, sans-serif',
          backgroundColor: '#eee',
          borderRadius: '3px',
          border: '1px solid #b4b4b4',
          boxShadow: '0 1px 1px rgba(0, 0, 0, 0.2), 0 2px 0 0 rgba(255, 255, 255, 0.7) inset',
          color: '#333',
          display: 'inline-block',
          fontSize: '1em',
          fontWeight: 400,
          lineHeight: 1,
          padding: '2px 4px',
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiTooltip: { styleOverrides: { tooltip: { fontSize: '1em' } } },
  },
  palette: {
    mode: 'dark',
    background: {
      default: '#2d2d2d',
    },
    secondary: {
      main: '#636D76',
      light: '#00000050',
      dark: '#2F3942',
      contrastText: '#fff',
    },
    warning: {
      main: '#f3e841',
      light: '#fde998',
      dark: '#f57c00',
    },
  },
  gradients: {
    primaryGradient: 'linear-gradient(-225deg, #2d2d2d 30%, #111111 95%)',
    secondaryGradient: 'linear-gradient(-180deg,#f2f7fb 30%,#fff)',
  },
  typography: {
    fontFamily: ['Poppins', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h1: {
      color: '#fff',
      marginTop: 30,
      fontSize: '2.25rem',
      lineHeight: '1.15em',
      fontWeight: 400,
      [breakpoints.down('sm')]: {
        fontSize: '1.5rem',
        marginTop: 0,
      },
    },
    subtitle1: {
      fontSize: '1.125rem',
      color: '#ffffffb3',
      marginTop: '10px',
      [breakpoints.down('md')]: {
        fontSize: '1rem',
      },
    },
  },
};
